import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import {
  MainWrapper,
  ModalHead,
  ContainerBodyTable,
  ContainerHeaderData,
  Flex,
  FlexBetween,
  ModalFooterNoPadding,
  TextReupload,
  TextNew,
} from './styles'
import { ContainerButtonModal } from './styles'
import IconPng from 'components/atoms/IconPng/index'
import { ContainerHeader } from './styles'
import ImportExcelTablePreview from './ImportExcelTablePreview'
import { Paragraph } from 'components/atoms/Texts/TxtParagraph'

const ic_cancel = require('App/assets/images/ic_cancel.png')

export class ImportExcelUploadModal extends PureComponent {
  render() {
    const { result } = this.props;

    return (
      <MainWrapper>
        <ModalHead>
          <ContainerHeader>
            <Flex>
              <Label lineheight={'29px'} size={'20px'} mb={'0px'} mr={'10px'}>
                Stock Opname Preview
              </Label>
              <Label lineheight={'29px'} size={'20px'} mb={'0px'}>
                {!result.isNew ? <TextReupload>(RE-UPLOAD)</TextReupload> : <TextNew>(NEW UPLOAD)</TextNew>}
              </Label>
            </Flex>
            <ButtonReg
              btnTxt={
                <IconPng srcIcon={ic_cancel} size={'auto'} h={'14'} showPointer={true} />
              }
              onClick={this.props.fnHandleCancel}
              width={'fit-content'}
              height={'34px'}
              transparent
            />
          </ContainerHeader>
        </ModalHead>
        <ContainerHeaderData>
          <FlexBetween>
            <div>
            <Flex>
              <Label mr={'15px'} mb={'0px'} size={'12px'}>Company</Label>
              <Label size={'12px'} mb={'0px'} weight={100}>{result.companyCode.value}</Label>
            </Flex>
            {
              result.companyCode.error && 
              (<Paragraph mb={'0px'} color='red' weight={'bold'} size={'12px'}>{result.companyCode.error}</Paragraph>)
            }
            </div>
            <div>
              <Flex>
                <Label mr={'10px'} mb={'0px'} size={'12px'}>Periode</Label>
                <Label size={'12px'} mb={'0px'} weight={100}>{result.period.value}</Label>
              </Flex>
              {
                result.period.error && 
                (<Paragraph mb={'0px'} color='red' weight={'bold'} size={'12px'}>{result.period.error}</Paragraph>)
              }
            </div>
           <div>
            <Flex>
              <Label mr={'10px'} mb={'0px'} size={'12px'}>Survey Date</Label>
              <Label size={'12px'} mb={'0px'} weight={100}>{result.surveyDate.value}</Label>
            </Flex>
            {
              result.surveyDate.error && 
              (<Paragraph mb={'0px'} color='red' weight={'bold'} size={'12px'}>{result.surveyDate.error}</Paragraph>)
            }
           </div>
          </FlexBetween>
          <Flex>
            <Label mr={'10px'} mb={'0px'} size={'12px'}>File Name</Label>
            <Label size={'12px'} mb={'0px'} weight={100}>{result.file.filename}</Label>
          </Flex>
        </ContainerHeaderData>
        <ContainerBodyTable>
          <ImportExcelTablePreview coalStockInventories={result.coalStockInventories} />
        </ContainerBodyTable>
        <ModalFooterNoPadding>
          <ContainerButtonModal>
            <ButtonReg
              bordered
              btnTxt={'Submit'}
              margin={'0 16px 0 0'}
              disabled={!this.props.isValidResult}
              onClick={this.props.fnSubmit}
            />
            <ButtonReg
              onClick={this.props.fnHandleCancel}
              transparent={true}
              bordered={true}
              btnTxt={'Cancel'}
            />
          </ContainerButtonModal>
        </ModalFooterNoPadding>
      </MainWrapper>
    )
  }
}

export default withTheme(ImportExcelUploadModal)
